import { sendGet } from './generic';
import IResult from '../../models/result/IResult';

export const microsoftAuthCallback = (query: string) : Promise<IResult<boolean>> => {
    return sendGet<boolean>(`/MicrosoftAuthorization/Callback${query}`)
}
